module.exports = __webpack_public_path__ + "static/media/survey_footer.02c970a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/survey_footer.png
// module id = 438
// module chunks = 1